import { Injectable } from "@angular/core";
import { DRCTEvent, DRCTPaymentReceipt, DRCTPayments } from "@drct-web-apps/ui-types";


@Injectable({
  providedIn: 'root'
})
export class UiServicesRegsitration {

  private _event: DRCTEvent | null = null;
  set event(event: DRCTEvent | null)  {
    this._event = event;
  }
  get event(): DRCTEvent | null  {
    return(this._event);
  }

  private _paymentData: DRCTPayments | null  = null
  set paymentData(data: DRCTPayments | null) {
    this._paymentData = data
  }
  get paymentData(): DRCTPayments | null {
    return(this._paymentData);
  }

  private _receiptData: DRCTPaymentReceipt | null  = null
  set receiptData(data: DRCTPaymentReceipt | null) {
    this._receiptData = data
  }
  get receiptData(): DRCTPaymentReceipt | null {
    return(this._receiptData);
  }

  public destroy(): void {
    this._event        = null;
    this._paymentData  = null;
    this._receiptData  = null;
  }
}